import {Constants} from './documentTypeConstants'
import { MokaiDocumentType } from '../../../model/dossier.model'



export function addDocumentType (documentType: MokaiDocumentType) {
    return {
        type: Constants.ADD_DOCUMENT_TYPE,
        payload: documentType
    } as const
}


export function updateDocumentType(documentType: MokaiDocumentType){
    return {
        type: Constants.UPDATE_DOCUMENT_TYPE,
        payload: documentType
    } as const
}


export function removeDocumentType(id:number){
    return {
        type: Constants.REMOVE_DOCUMENT_TYPE,
        payload: id
    } as const
}